module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7pgCC"))).then(() => parcelRequire('cvs7o'));